interface DialogflowWidget extends HTMLElement {
	renderCustomText: (text: string) => void;
	openChat: () => void;
	closeChat: () => void;
}

const openChat = () => {
	const widget = document.querySelector(
		'df-messenger-chat-bubble'
	) as DialogflowWidget | null;
	if (widget) {
		widget.openChat();
	}
};

const closeChat = () => {
	const widget = document.querySelector(
		'df-messenger-chat-bubble'
	) as DialogflowWidget | null;
	if (widget) {
		widget.closeChat();
	}
};

const hideChatBubble = () => {
	const bubble = document.querySelector(
		'df-messenger-chat-bubble'
	) as HTMLElement | null;
	if (bubble) {
		bubble.style.display = 'none';
	}
};

const showChatBubble = () => {
	const bubble = document.querySelector(
		'df-messenger-chat-bubble'
	) as HTMLElement | null;
	if (bubble) {
		bubble.style.display = 'block';
	}
};

export { openChat, closeChat, hideChatBubble, showChatBubble };
